import React, { ReactNode } from "react";
import { Link } from "react-router-dom";
import { NativeHtml } from "../../../../types/nativeHtml";

interface LinkNoPathProps extends NativeHtml {
	children?: ReactNode;
	block?: boolean;
	disabled?: boolean;
}

const LinkNoPath: React.FC<LinkNoPathProps> = ({ children, style, className, block, disabled = true }) => {
	const defaultStyle = {
		display: block ? "block" : "inline",
	};
	const customLinkStyle = { ...style };

	const linkStyle = { ...defaultStyle, ...customLinkStyle };

	return (
		<Link
			className={className}
			style={linkStyle}
			to="#"
			onClick={e => {
				e.preventDefault();
			}}
			aria-disabled={disabled}
		>
			{children}
		</Link>
	);
};

export default LinkNoPath;
